import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const AlertIconDark: React.FC<IconSvgProps> = (props) => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24.6113 7.58541C24.8033 7.2495 25.2876 7.24951 25.4796 7.58541L42.0332 36.5543C42.2237 36.8876 41.983 37.3024 41.5991 37.3024H8.49183C8.10792 37.3024 7.86723 36.8876 8.05771 36.5543L24.6113 7.58541Z"
      fill="#D44842"
      stroke="#E6E6E6"
      strokeWidth="3"
    />
    <mask
      id="mask0_11545_326538"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="-6"
      y="-7"
      width="37"
      height="43"
    >
      <ellipse cx="12.4362" cy="14.0823" rx="17.9365" ry="20.9185" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_11545_326538)">
      <path
        d="M24.6113 7.58541C24.8033 7.2495 25.2876 7.24951 25.4796 7.58541L42.0332 36.5543C42.2237 36.8876 41.983 37.3024 41.5991 37.3024H8.49183C8.10792 37.3024 7.86723 36.8876 8.05771 36.5543L24.6113 7.58541Z"
        fill="#F84B43"
        stroke="white"
        strokeWidth="3"
      />
    </g>
    <rect
      x="24.1238"
      y="28.2566"
      width="12.3077"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 24.1238 28.2566)"
      fill="#E6E6E6"
    />
    <rect
      x="24.1238"
      y="34.2804"
      width="3"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 24.1238 34.2804)"
      fill="#E6E6E6"
    />
  </svg>
)

export const AlertIconLight: React.FC<IconSvgProps> = (props) => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24.6113 7.58531C24.8032 7.2494 25.2876 7.2494 25.4795 7.58531L42.0332 36.5542C42.2236 36.8875 41.983 37.3022 41.5991 37.3022H8.49177C8.10786 37.3022 7.86717 36.8875 8.05765 36.5542L24.6113 7.58531Z"
      fill="#D44842"
      stroke="#121212"
      strokeWidth="3"
    />
    <mask
      id="mask0_11545_303826"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="-6"
      y="-7"
      width="37"
      height="43"
    >
      <ellipse cx="12.436" cy="14.0823" rx="17.9365" ry="20.9185" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_11545_303826)">
      <path
        d="M24.6113 7.58531C24.8032 7.2494 25.2876 7.2494 25.4795 7.58531L42.0332 36.5542C42.2236 36.8875 41.983 37.3022 41.5991 37.3022H8.49177C8.10786 37.3022 7.86717 36.8875 8.05765 36.5542L24.6113 7.58531Z"
        fill="#F84B43"
        stroke="#454643"
        strokeWidth="3"
      />
    </g>
    <rect
      x="24.1235"
      y="28.2566"
      width="12.3077"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 24.1235 28.2566)"
      fill="#121212"
    />
    <rect
      x="24.1235"
      y="34.2805"
      width="3"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 24.1235 34.2805)"
      fill="#121212"
    />
  </svg>
)
